import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlObjetoLicitacao = '/service/materiais/objetoLicitacao/'

class ObjetoLicitacaoService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    getObjetoLicitacao() {
        return this.conex.get(urlObjetoLicitacao + 'todos/')
    }
}

export default ObjetoLicitacaoService
